import { calculateDistance } from "./distance";
import type { PublicJobPost } from "./job-types";

/** Bengaluru beachhead — default proximity anchor when user location is unavailable. */
export const BENGALURU_CENTER = { latitude: 12.9716, longitude: 77.5946 };

function jobDistanceKm(
  job: PublicJobPost,
  origin: { latitude: number; longitude: number },
): number {
  const lat = job.hospital_profiles?.latitude;
  const lng = job.hospital_profiles?.longitude;
  if (lat == null || lng == null) return Infinity;
  return calculateDistance(origin.latitude, origin.longitude, lat, lng);
}

/** Sort jobs nearest-first; falls back to Bengaluru center when no user location. */
export function sortJobsByProximity(
  jobs: PublicJobPost[],
  userLocation?: { latitude: number; longitude: number } | null,
): PublicJobPost[] {
  const origin = userLocation ?? BENGALURU_CENTER;

  return [...jobs].sort((a, b) => {
    const distA = jobDistanceKm(a, origin);
    const distB = jobDistanceKm(b, origin);
    if (distA !== distB) return distA - distB;
    return a.shift_date.localeCompare(b.shift_date);
  });
}
